const messages = {
    hello: 'Welcome',
    sign_in: 'Login'
}  

export default messages;